<template>
  <article class="changePassword">
    <h5 class="changePassword__title">
      Alterar senha
    </h5>

    <form
      v-if="loaded"
      @submit.prevent="submit()"
      class="changePassword__form"
    >
      <dr-field
        v-for="(field, name) in formData"
        v-bind:form.sync="formData"
        v-bind:field.sync="field"
        v-bind:value.sync="formData[name].value"
        v-bind:validators.sync="$v.formData[name]"
        v-bind:apiErrors.sync="apiErrors[name]"
        :id="name"
        :ref="name"
        :key="'main_'+name"
        prefix="form1"
        class="text-left"
      />

      <div class="changePassword__footer">
        <div class="changePassword__footer-col">
          <dr-submit
            :disabled="$v.$invalid"
            text="Salvar"
            :sending="sending"
          />
        </div>

        <div class="changePassword__footer-col">
          <a @click="$emit('change', true)">
            <strong>Voltar para Meus Dados</strong>
          </a>
        </div>
      </div>
    </form>
  </article>
</template>

<script>
import drField from '@/components/form/field'
import drSubmit from '@/components/form/submit'
import {formData, validations} from '@/data/formData/userPassword'

export default {
  props: [
    'dataForm'
  ],
  components: {
    drField,
    drSubmit
  },
  data () {
    return {
      loaded: false,
      formData: formData,
      apiErrors: this.fn_BUILD_API_ERRORS(formData),
      sending: false
    }
  },
  validations: {
    formData: validations
  },
  mounted () {
    if (this.fn_IS_SECRETARY()) {
      delete this.formData.currentPassword
    }
    for (let field in this.formData) {
      this.formData[field].value = null
    }
    this.loaded = true
  },
  methods: {
    submit () {
      this.sending = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.sending = false
        return
      }
      let data = this.fn_EXPAND_OBJECT(this.formData)
      let form = {}
      if (!this.fn_IS_DOCTOR()) delete data.currentPassword
      form[this.fn_IS_DOCTOR() ? 'password' : 'change_password'] = data
      this.$http.put(`/${this.fn_IS_DOCTOR() ? 'doctor/password' : 'change_password'}`, form, this.$store.getters.getAuthHeader).then(
        (res) => {
          this.$store.dispatch('setModalAlert', {
            title: 'Sucesso',
            body: 'Senha alterada com sucesso',
            size: 'md',
            active: true
          })
          this.sending = false
          for (let field in this.formData) {
            this.formData[field].value = null
          }
          this.$emit('change', true)
        }
      ).catch(
        (err) => {
          console.log(err)
          if (err.status === 400 || err.code === 400) {
            this.fn_FLATTEN_OBJECT(err.errors.children).then(
              (res) => {
                let errs = []
                for (let field in res) {
                  this.apiErrors[field.replace(/.children|.errors/g, '')] = res[field]
                  errs.push(res[field])
                }
                this.$store.dispatch('setModalAlert', {
                  title: 'Erro',
                  body: errs.join('\n'),
                  size: 'md',
                  active: true
                })
                this.sending = false
              }
            )
          } else {
            this.sending = false
            this.$store.dispatch('setModalAlert', this.ERROR_MESSAGES.modal.server)
          }
        }
      )
    }
  }
}
</script>
